// Hubspot Integration with Cookiebot Consent Management
document.addEventListener("DOMContentLoaded", function () {
  var _Cookiebot$consent;

  function loadHubspot() {
    if (document.getElementById('hubspot-embed-script')) return;
    var s = document.createElement('script');
    s.id = 'hubspot-embed-script';
    s.src = 'https://js.hs-scripts.com/25899970.js';
    s.dataset.blockingmode = 'auto';
    s.async = true;
    document.head.appendChild(s);
  }

  if (window.Cookiebot && (_Cookiebot$consent = Cookiebot.consent) !== null && _Cookiebot$consent !== void 0 && _Cookiebot$consent.marketing) {
    loadHubspot();
  } else {
    window.addEventListener('CookiebotOnAccept', function () {
      var _Cookiebot$consent2;

      if ((_Cookiebot$consent2 = Cookiebot.consent) !== null && _Cookiebot$consent2 !== void 0 && _Cookiebot$consent2.marketing) {
        loadHubspot();
      }
    });
  }
});